<template>
  <div
    class="overseas-contact-container"
    :class="{
      'overseas-contact-container--full': showSuccess,
    }"
  >
    <div v-if="!showSuccess" class="overseas-contact">
      <div class="overseas-contact__title">Contact Enterprise Sales at Rendora</div>
      <a-divider />
      <SubmitForm :params="data?.data" @submit="onSubmit" />
    </div>
    <div v-else class="overseas-contact-success">
      <iconpark-icon name="circle-success" size="52"></iconpark-icon>
      <div class="overseas-contact-success__title">Submit successfully</div>
      <div class="overseas-contact-success__desc">Thank you for your support</div>
      <a-button type="primary" class="overseas-contact-success__btn" @click="onClose">
        Close
      </a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { addEnContact, getEnContactInfo } from '~/api/index';
import type { ContactEnAddRequest } from '~/api/interface/contact';
import SubmitForm from './components/form.vue';

const showSuccess = ref(false);

const { data } = useAsyncData(getEnContactInfo);

const onSubmit = async (values: ContactEnAddRequest) => {
  await addEnContact(values);
  showSuccess.value = true;
};

const onClose = () => {
  window.close();
};
</script>

<style lang="scss" scoped src="./styles/pc.scss" />
